import React from 'react';

import SoilMoistureIcon from './soilMoistureIcon.svg?react';

function FarmbotSoilMoistureIcon() {
  return <SoilMoistureIcon width={18} />;
}

export default FarmbotSoilMoistureIcon;
